import React, { FC } from 'react';
import cs from 'classnames';
import { VIEW_MODE } from '../../utils/helpers';
import { StoreTemplate } from '../../context/TemplateContext';
import s from './WixStudioTemplateDemo.scss';
import { buildIframeUrl } from '../../utils/urlBuilders';

type Props = {
  template: StoreTemplate;
  dataHook?: string;
  viewMode: string;
};

export const WixStudioTemplateDemo: FC<Props> = ({ template, viewMode, dataHook }) => {
  const isMobile = viewMode === VIEW_MODE.MOBILE;
  const url = buildIframeUrl(template.url, { showMobileView: isMobile });

  return (
    <div data-hook={dataHook} className={s.container}>
      <iframe
        title={template.title}
        src={url}
        className={cs(s.iframe, {
          [s.tablet]: viewMode === VIEW_MODE.TABLET,
          [s.mobile]: viewMode === VIEW_MODE.MOBILE,
        })}
      />
    </div>
  );
};
